import React			   from 'react';
import PublicLayoutTheme   from 'theme/components/layout/publiclayout/PublicLayout';

function PublicLayout(props) {
	return <PublicLayoutTheme {...props}/>;
}

export default PublicLayout;